// extracted by mini-css-extract-plugin
module.exports = {"containerFooter":"homehub_footer_containerFooter__4NRLw","fadein":"homehub_footer_fadein__Dp912","loading":"homehub_footer_loading__5QIsz"};